import { render } from "./Login.vue?vue&type=template&id=66166aea&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-66166aea"

export default script